import { IDemoPersistedRoiRequest } from "../../../features/roi-request-create/model/roi-request-create.storage";

export const MOCK_ROI_REQUESTS: IDemoPersistedRoiRequest[] = [
  {
    request_id: 584523,
    state: "DRAFT",
    total_selected_items_count: 11,
    data: [
      { section_id: "flowsheets", selection: ["flowsheet-1", "flowsheet-2"] },
      { section_id: "allergies", selection: ["allergy-1", "allergy-2"] },
      { section_id: "directives", selection: ["directive-1"] },
      { section_id: "documents", selection: ["document-1", "document-2"] },
      { section_id: "immunizations", selection: ["immunization-1"] },
      { section_id: "medications", selection: ["medication-1", "medication-2"] },
      { section_id: "problems", selection: ["problem-1"] },
    ],
    created_at: "2026-02-23T08:11:00.000Z",
    saved_at: "2026-02-23T08:11:00.000Z",
    created_by: "John Smith",
  },
  {
    request_id: 584519,
    state: "DRAFT",
    total_selected_items_count: 8,
    data: [
      { section_id: "flowsheets", selection: ["flowsheet-3", "flowsheet-4"] },
      { section_id: "directives", selection: ["directive-2", "directive-4"] },
      { section_id: "encounters", selection: ["encounter-1", "encounter-2"] },
      { section_id: "lab-results", selection: ["lab-result-1", "lab-result-2"] },
    ],
    created_at: "2026-02-20T12:12:00.000Z",
    saved_at: "2026-02-23T08:11:00.000Z",
    created_by: "John Smith",
  },
  {
    request_id: 584511,
    state: "DRAFT",
    total_selected_items_count: 6,
    data: [
      { section_id: "allergies", selection: ["allergy-4"] },
      { section_id: "documents", selection: ["document-4", "document-5"] },
      { section_id: "medications", selection: ["medication-4", "medication-5"] },
      { section_id: "problems", selection: ["problem-3"] },
    ],
    created_at: "2026-02-19T07:23:00.000Z",
    saved_at: "2026-02-23T08:11:00.000Z",
    created_by: "Michael Johnson",
  },
  {
    request_id: 584507,
    state: "COMPLETED",
    total_selected_items_count: 9,
    data: [
      { section_id: "flowsheets", selection: ["flowsheet-5", "flowsheet-6"] },
      { section_id: "allergies", selection: ["allergy-5"] },
      { section_id: "documents", selection: ["document-6", "document-7"] },
      { section_id: "encounters", selection: ["encounter-3", "encounter-4"] },
      { section_id: "lab-results", selection: ["lab-result-3", "lab-result-4"] },
    ],
    created_at: "2026-02-19T07:10:00.000Z",
    saved_at: "2026-02-19T12:33:00.000Z",
    created_by: "Michael Johnson",
    completed_by: "Michael Johnson",
  },
  {
    request_id: 584498,
    state: "COMPLETED",
    total_selected_items_count: 5,
    data: [
      { section_id: "directives", selection: ["directive-3"] },
      { section_id: "documents", selection: ["document-8"] },
      { section_id: "immunizations", selection: ["immunization-2", "immunization-3"] },
      { section_id: "problems", selection: ["problem-4"] },
    ],
    created_at: "2026-02-19T07:10:00.000Z",
    saved_at: "2026-02-21T09:05:00.000Z",
    created_by: "Emily Davis",
    completed_by: "John Smith",
  },
  {
    request_id: 584472,
    state: "COMPLETED",
    total_selected_items_count: 7,
    data: [
      { section_id: "flowsheets", selection: ["flowsheet-7"] },
      { section_id: "allergies", selection: ["allergy-6"] },
      { section_id: "documents", selection: ["document-9"] },
      { section_id: "medications", selection: ["medication-6", "medication-7"] },
      { section_id: "lab-results", selection: ["lab-result-5", "lab-result-6"] },
    ],
    created_at: "2026-01-12T12:33:00.000Z",
    saved_at: "2026-01-12T12:33:00.000Z",
    created_by: "Sophia Brown",
    completed_by: "John Smith",
  },
];
